// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2m2nI","fileBtn":"File_fileBtn__3g4DZ","closeBtn":"File_closeBtn__11Sfi","fileSelected":"File_fileSelected__1hUIv","disabled":"File_disabled__nlJ1q"};